<div class="titlebar">
  <h3>{{ "Template.CockpitComponent.subHeader_supplierHomepage" | translate }}</h3>
</div>

@if (loading) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (!loading) {
  <div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs border-bottom-0 ps-2">
      @if (showDataUpload) {
        <li ngbNavItem>
          <button ngbNavLink>{{ "Template.CockpitComponent.btn_dataManagement" | translate }}</button>
          <ng-template ngbNavContent>
            @if (currentPartyId) {
              <app-data-management [partyId]="currentPartyId"></app-data-management>
            }
          </ng-template>
        </li>
      }
      @if (showDataApproval) {
        <li ngbNavItem>
          <button ngbNavLink>{{ "Template.CockpitComponent.btn_dataAccesses" | translate }}</button>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-6">
                @if (currentPartyId) {
                  <app-supplier-contact [partyId]="currentPartyId" [type]="'SUPPLIER_DATA'"></app-supplier-contact>
                }
              </div>
              <div class="col-6">
                @for (dataStream of dataStreams; track dataStream) {
                  <div>
                    @if (dataStreams && dataStreams.length > 1) {
                      <h4 class="fs-5 text-primary">{{ dataStream.supplier?.attributes?.['NAME'] }}</h4>
                    }
                    @if (currentPartyId) {
                      <app-auto-approve [partyId]="currentPartyId" [dataStream]="dataStream" (refresh)="refreshDataAccesses()"></app-auto-approve>
                    }
                  </div>
                }
              </div>
            </div>
            <hr class="mb-5" />
            @for (dataStream of dataStreams; track dataStream) {
              <div>
                @if (dataStreams && dataStreams.length > 1) {
                  <h4 class="fs-5 text-primary">{{ dataStream.supplier?.attributes?.['NAME'] }}</h4>
                }
                <app-data-approvals [dataStreamId]="dataStream.id" [refresh]="dataAccessesRefreshSubject"></app-data-approvals>
              </div>
            }
          </ng-template>
        </li>
      }
      @if (showOrderApproval) {
        <li ngbNavItem>
          <button ngbNavLink>{{ "Template.CockpitComponent.btn_orderAccesses" | translate }}</button>
          <ng-template ngbNavContent>
            <div class="row">
              <div class="col-4">
                @if (currentPartyId) {
                  <app-supplier-contact [partyId]="currentPartyId" [type]="'SUPPLIER_ORDERS'"></app-supplier-contact>
                }
              </div>
              <div class="col-4">
                @if (currentPartyId) {
                  <app-delivery-conditions [partyId]="currentPartyId"></app-delivery-conditions>
                }
              </div>
              <div class="col-4">
                @if (currentPartyId) {
                  <app-supplier-header-image-upload [partyId]="currentPartyId"></app-supplier-header-image-upload>
                }
              </div>
            </div>
            <hr class="mb-5" />
            @if (currentPartyId) {
              <app-order-accesses [partyId]="currentPartyId"></app-order-accesses>
            }
          </ng-template>
        </li>
      }
    </ul>
    <div class="p-3 border rounded-3" [ngbNavOutlet]="nav"></div>
  </div>
}
